export const copyTextToClipboard = async (
  text: string,
  onError?: (error: Error) => void
): Promise<boolean> => {
  let copySuccess = false;
  if (navigator.clipboard) {
    try {
      await navigator.clipboard.writeText(text);
      copySuccess = true;
    } catch (error) {
      onError ? onError?.(error) : console.error(error);
    }
  } else {
    copySuccess = DEPRECATED_copyTextToClipboard(text);
  }
  if (!copySuccess) {
    onError ? onError?.(new Error("Failed to copy to clipboard")) : console.error("Failed to copy to clipboard");
  }
  return copySuccess;
};

/**
 * Fallback legacy function to copy text to clipboard for browsers that don't support navigator.clipboard.writeText
 * @reference https://github.com/sindresorhus/copy-text-to-clipboard/blob/main/index.js
 * @deprecated Use navigator.clipboard.writeText instead
 */
const DEPRECATED_copyTextToClipboard = (
  text,
  { target = document.body } = {}
) => {
  if (typeof text !== "string") {
    throw new TypeError(
      `Expected parameter \`text\` to be a \`string\`, got \`${typeof text}\`.`
    );
  }

  const element = document.createElement("textarea");
  const previouslyFocusedElement = document.activeElement;

  element.value = text;

  // Prevent keyboard from showing on mobile
  element.setAttribute("readonly", "");

  element.style.contain = "strict";
  element.style.position = "absolute";
  element.style.left = "-9999px";
  element.style.fontSize = "12pt"; // Prevent zooming on iOS

  const selection = document.getSelection();
  const originalRange = selection.rangeCount > 0 && selection.getRangeAt(0);

  target.append(element);
  element.select();

  // Explicit selection workaround for iOS
  element.selectionStart = 0;
  element.selectionEnd = text.length;

  let isSuccess = false;
  try {
    isSuccess = document.execCommand("copy");
  } catch {}

  element.remove();

  if (originalRange) {
    selection.removeAllRanges();
    selection.addRange(originalRange);
  }

  // Get the focus back on the previously focused element, if any
  if (previouslyFocusedElement instanceof HTMLElement) {
    previouslyFocusedElement.focus();
  }

  return isSuccess;
};
